









































import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { useToast } from '../toast.composable';
import { ToastPlacement } from '../enums/toast-placement';
import Toast from './Toast.vue';

export default defineComponent({
  components: {
    Toast,
  },
  props: {
    offset: {
      type: Object as PropType<{ top: number; right: number; bottom: number; left: number }>,
      default: () => ({ top: 16, right: 16, bottom: 16, left: 16 }),
    },
  },
  setup(props) {
    const { queue } = useToast();

    const topLeft = computed(() =>
      queue.value.filter(toast => toast.options.placement === ToastPlacement.TopLeft).reverse()
    );
    const topRight = computed(() =>
      queue.value.filter(toast => toast.options.placement === ToastPlacement.TopRight).reverse()
    );
    const bottomLeft = computed(() =>
      queue.value.filter(toast => toast.options.placement === ToastPlacement.BottomLeft)
    );
    const bottomRight = computed(() =>
      queue.value.filter(toast => toast.options.placement === ToastPlacement.BottomRight)
    );
    const leave = (el: unknown) => {
      if (el instanceof HTMLElement) {
        el.style.top = `${el.offsetTop}px`;
        el.style.position = 'absolute';
      }
    };

    const offsetStyle = computed(() => ({
      top: `${props.offset.top}px`,
      right: `${props.offset.right}px`,
      bottom: `${props.offset.bottom}px`,
      left: `${props.offset.left}px`,
    }));

    return {
      topLeft,
      topRight,
      bottomLeft,
      bottomRight,
      leave,
      offsetStyle,
    };
  },
});
